<template>
    <FormSection
        title="Episode Management"
        type="his-section"
        :full-height="false"
        :application-id="Number(application)"
    >
        <template #content>
            <section class="row py-3 pb-0 g-0">
                <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="row">
                            <div class="form-group col-12 col-lg-12 pe-lg-12">
                                <label for="date-of-birth">
                                    Start of Care Date
                                    <span class="text-danger">*</span>
                                </label>
                                <DatePicker :getDate="handleDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="StartofCareDate"
                                            type="text"
                                            :class="`form-control ${
                                                v$.referral.Demographics.StartofCareDate.$error ||
                                                errors.Demographics.includes('StartofCareDate')
                                                    ? 'border border-warning rounded p-2'
                                                    : ''
                                            }`"
                                            placeholder="Enter Date"
                                            :value="formatDateInput(referral.Demographics.StartofCareDate)"
                                            @blur="v$.referral.Demographics.StartofCareDate.$touch"
                                            @change="handleDateInputChange"
                                            autocomplete="off"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-12">
                                <label for="date-of-birth">
                                    Episode Start Date
                                    <span class="text-danger">*</span>
                                </label>
                                <DatePicker :getDate="handleDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="EpisodeStartDate"
                                            type="text"
                                            :class="`form-control ${
                                                v$.referral.Demographics.EpisodeStartDate.$error ||
                                                errors.Demographics.includes('EpisodeStartDate')
                                                    ? 'border border-warning rounded p-2'
                                                    : ''
                                            }`"
                                            placeholder="Enter Date"
                                            :value="formatDateInput(referral.Demographics.EpisodeStartDate)"
                                            @blur="v$.referral.Demographics.EpisodeStartDate.$touch"
                                            @change="handleDateInputChange"
                                            autocomplete="off"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="row">
                            <p class="mb-2 d-flex align-items-center field-title">
                                Create episode &amp; schedule visit after saving
                            </p>
                            <div
                                :class="`${
                                    v$.referral.Demographics.CreateEpisodeAndScheduleVisit.$error ||
                                    errors.Demographics.includes('CreateEpisodeAndScheduleVisit')
                                        ? 'border border-warning p-2 rounded'
                                        : ''
                                }`"
                            >
                                <div v-for="option of Options" :key="`${option.value}-${option.label}`">
                                    <div class="form-check d-flex custom-checkbox pb-1 col-12">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`${option.value}-${option.label}`"
                                            :value="option.value"
                                            :checked="isChecked(option)"
                                            @change="handleEpisodeChange(option.value)"
                                            @blur="v$.referral.Demographics.CreateEpisodeAndScheduleVisit.$touch"
                                        />
                                        <label
                                            class="form-check-label ms-1 col-12"
                                            :for="`${option.value}-${option.label}`"
                                        >
                                            {{ option.label }}
                                        </label>
                                    </div>
                                    <div v-if="referral.Demographics.CreateEpisodeAndScheduleVisit === option.value">
                                        <div
                                            v-for="type of OasisDisciplineTypeOptions[
                                                referral.Demographics.CreateEpisodeAndScheduleVisit
                                            ]"
                                        >
                                            <div class="form-check d-flex pb-1 col-12 ms-4 mt-2 mb-2">
                                                <input
                                                    type="radio"
                                                    class="form-check-input"
                                                    :id="`${type.value}-${type.label}`"
                                                    :value="type.value"
                                                    @change="handleOasisType(type.value)"
                                                    :checked="referral.Demographics.OasisDisciplineType === type.value"
                                                />
                                                <label
                                                    class="form-check-label ms-1 col-12"
                                                    :for="`${type.value}-${type.label}`"
                                                >
                                                    {{ type.label }}
                                                </label>
                                            </div>
                                        </div>
                                        <div
                                            v-if="
                                                referral.Demographics.CreateEpisodeAndScheduleVisit === 5 ||
                                                referral.Demographics.CreateEpisodeAndScheduleVisit === 4
                                            "
                                            class="form-group col-12 ps-4 mt-2 mb-2"
                                        >
                                            <label> Recertification Date </label>
                                            <DatePicker :getDate="handleDateChange">
                                                <div class="input-group date datepickerInput">
                                                    <input
                                                        name="recert-Date"
                                                        type="text"
                                                        class="form-control"
                                                        placeholder="Enter Date"
                                                        :value="
                                                            formatDateInput(referral.Demographics.RecertificationDate)
                                                        "
                                                        @change="handleDateInputChange"
                                                        autocomplete="off"
                                                    />
                                                    <div class="input-group-addon input-group-append">
                                                        <div class="input-group-text">
                                                            <i class="fa fa-calendar"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </DatePicker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="form-check d-flex pb-1 col-12">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="IsFaceToFaceEncounterCreated"
                                        v-model="referral.Demographics.IsFaceToFaceEncounterCreated"
                                    />
                                    <label class="form-check-label ms-1 col-12" for="IsFaceToFaceEncounterCreated">
                                        Track F2F Documentation
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EpisodeManagement.ts"></script>
